export const environment = {
  production: true,
  // @ts-ignore
  KEYCLOAK_URL: window["env"]["keycloakUrl"]|| 'http://localhost:8081/auth/',
  KEYCLOAK_CLIENT_ID: "AngularManager",
  KEYCLOAK_REALM: "ABRFlow",
  //apiUrl: 'http://80.211.148.221:9090',
  // @ts-ignore
  apiUrl: window["env"]["apiUrl"]||'http://80.211.148.221:9090',
  authRequireHttps: false,
  authDebug: false
};
